function initContentSliderCarousel() {
    let $contentSliderScroll = $('.content-slider__slider');
    if($contentSliderScroll.length < 1) return;

    let autoPlay = true;
    if($($contentSliderScroll).hasClass('')) {
        autoPlay = false;
    }

    $contentSliderScroll.not('.slick-initialized').slick({
        dots: true,
        infinite: true,
        arrows: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: autoPlay,
        autoplaySpeed: 5000,
        mobileFirst: false,
        centerMode: true,
        dotsClass: 'slick-dots slider-progress-bar',
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    centerMode: false
                }
            }
        ]
    });
    updateSliderPagination();
}

function initContentSliderPagination() {
    $('.content-slider__slider').on('init', function (event, slick) {
        if($('.slider-paging').length <= 0) {
            $('.content-slider__slider .slider-progress-bar').append('<li class="slider-paging"></li>');
            // currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
            $('.slider-paging').text(1 + '/' + slick.slideCount);
        }
    });
    initContentSliderCarousel();
}

function updateSliderPagination() {
    $('.content-slider__slider').on('reInit afterChange', function (event, slick, currentSlide) {
        var i = (currentSlide || 0) + 1;
        $('.slider-paging').text(i + '/' + slick.slideCount);
    });
}

function bindVideo() {
    var showVideo = $(this).attr('data-show-video');
    if(showVideo === 'true' || showVideo === 'True') {
        console.log(showVideo);
        var src = $(this).attr('data-video');
        var video = '<div class="iframe-container video-iframe"><iframe src="' + src + '"frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen="" title="Lofoten from Above" data-ready="true"></iframe></div>';
        $('#content-slider-modal-video').html(video);
    }
}

$(function () {
    initContentSliderPagination();

    $('.content-slider__slide-img').on('click', bindVideo);

    $(window).resize(function () {
        initContentSliderPagination();
    });

    $('#content-slider-modal').on('hidden.bs.modal', function () {
        $('#content-slider-modal-video').html('');
    });
});
